//extracted from icon-63-36-txsend.svg
import React from 'react';
export const viewbox = '0 0 63.55 36.25';

export const content = (
  <>
    <defs>
      <style>
        .cls-1
        {
          '{fill:none;stroke:#009ca6;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'
        }
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="replace-folder">
          <g id="replace-folder-2" data-name="replace-folder">
            <g id="Group_72" data-name="Group 72">
              <g id="Group_3852" data-name="Group 3852">
                <path
                  id="Path_2416"
                  data-name="Path 2416"
                  className="cls-1"
                  d="M60.55,24.16h-16"
                />
                <path
                  id="Path_2417"
                  data-name="Path 2417"
                  className="cls-1"
                  d="M56.55,31.64l6-7.48-6-7.47"
                />
              </g>
              <path
                id="Path_2419"
                data-name="Path 2419"
                className="cls-1"
                d="M31.86,35.25H6.15A5.35,5.35,0,0,1,1,29.72V1H13.35l5.14,7.73H37v21A5.34,5.34,0,0,1,31.86,35.25Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </>
);

export default { viewbox, content };
